import { Stack, Typography } from "@mui/material";
import type { InvestorCommunication } from "../../../api/types/investorCommunicationsTypes";
import { investorCommunicationTypeCaptionsMap } from "../../../utilities/enumCaptions";
import InvestorCommunicationStatusTag from "@entrilia/shared/components/InvestorCommunicationStatusTag";
import InvestorCommunicationTypeAvatar from "./InvestorCommunicationTypeAvatar";

interface Props {
  investorCommunication: InvestorCommunication;
}

const InvestorCommunicationPageTitle = ({ investorCommunication }: Props) => (
  <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", py: 1.5 }}>
    <InvestorCommunicationTypeAvatar type={investorCommunication.type} />
    <Stack spacing={0.5}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="h6">{investorCommunication.content?.title || "Untitled"}</Typography>
        <InvestorCommunicationStatusTag status={investorCommunication.status} />
      </Stack>
      <Typography variant="caption" color="textSecondary">
        {investorCommunicationTypeCaptionsMap[investorCommunication.type]}
      </Typography>
    </Stack>
  </Stack>
);

export default InvestorCommunicationPageTitle;
